export default "__VITE_ASSET__BdYgDQ1q__"